export type PitchType =
    | 'FF'
    | 'SI'
    | 'FT'
    | 'FC'
    // Offspeed
    | 'CH'
    | 'FS'
    | 'FO'
    | 'SC'
    // Breaking
    // Curveballs
    | 'CU'
    | 'KC'
    | 'CS'
    // Sliders
    | 'SL'
    | 'ST'
    | 'SV'
    // Weird
    | 'KN'
    // OTher
    | 'EP'
    | 'FA'
    | 'IN'
    | 'PO'

const pitchTypeOrder = {
    // Fastballs
    FF: 10,
    SI: 20,
    FT: 30,
    FC: 40,

    // Offspeed
    CH: 50,
    FS: 60,
    FO: 70,
    SC: 80,

    // Breaking
    // Curveballs
    CU: 90,
    KC: 100,
    CS: 110,
    // Sliders
    SL: 120,
    ST: 130,
    SV: 140,
    // Weird
    KN: 150,
    // OTher
    EP: 160,
    FA: 170,
    IN: 180,
    PO: 190,
} as const

export default pitchTypeOrder

export function getPitchWeight(pitchType: PitchType) {
    return pitchTypeOrder[pitchType] || Number.MAX_SAFE_INTEGER
}

export function sortPitchTypes(types: PitchType[]) {
    return types.sort((a, b) => getPitchWeight(a) - getPitchWeight(b))
}
